import { cx } from "../../lib/cx";

type Props = {
  /** How many placeholder rows; roughly the rows the real list will show. */
  rows?: number;
  className?: string;
  "data-testid"?: string;
};

/**
 * Grey pulsing rows that hold a list's place while it loads, so the page keeps
 * its shape instead of flashing "Loading…" and then jumping.
 */
export function SkeletonRows({ rows = 6, className, "data-testid": testId }: Props) {
  return (
    <div
      // cx does not resolve Tailwind conflicts, so a caller's className replaces the default padding.
      className={cx("flex flex-col gap-3", className ?? "py-2")}
      data-testid={testId}
      aria-busy="true"
      role="status"
      aria-label="Loading"
    >
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="h-8 animate-pulse rounded-ds-row bg-ds-hover" />
      ))}
    </div>
  );
}
